import { CollabDocSerializationError } from '@common/collab/types/collab-doc-serialization-error.type';
import { FlareEditorElementAttributeWhitelist } from '@common/flare/constants/flare-editor-element-attribute-whitelist.constant';
import { FlareSerializer } from '@common/flare/flare-serializer';
import { BlockContainerSchemaPlugin } from '@common/flare/schema/block-container-schema.plugin';
import { BrSchemaPlugin } from '@common/flare/schema/br-schema-plugin';
import { CustomAttributesSchemaPlugin } from '@common/flare/schema/custom-attributes-schema-plugin';
import { DefinitionListSchemaPlugin } from '@common/flare/schema/definition-list-schema-plugin';
import { FlareDocSchemaPlugin } from '@common/flare/schema/flare-doc-schema-plugin';
import { FormSchemaPlugin } from '@common/flare/schema/form-schema.plugin';
import { FramesetSchemaPlugin } from '@common/flare/schema/frameset-schema.plugin';
import { HeadSchemaPlugin } from '@common/flare/schema/head-schema.plugin';
import { HeadingSchemaPlugin } from '@common/flare/schema/heading-schema-plugin';
import { HrSchemaPlugin } from '@common/flare/schema/hr-schema.plugin';
import { HtmlTagsSchemaPlugin } from '@common/flare/schema/html-tags-schema-plugin';
import { IFrameSchemaPlugin } from '@common/flare/schema/iframe-schema-plugin';
import { ImageSchemaPlugin } from '@common/flare/schema/image-schema-plugin';
import { LegacySchemaNodes, LegacySchemaPlugin } from '@common/flare/schema/legacy-schema.plugin';
import { LinkSchemaPlugin } from '@common/flare/schema/link-schema-plugin';
import { ListSchemaPlugin } from '@common/flare/schema/list-schema-plugin';
import { MadCapAnnotationSchemaPlugin } from '@common/flare/schema/madcap-annotation-schema-plugin';
import { MadCapCentralCDataSchemaPlugin } from '@common/flare/schema/madcap-central-cdata-schema.';
import { MadCapCentralCommentSchemaNodes, MadCapCentralCommentSchemaPlugin } from '@common/flare/schema/madcap-central-comment-schema-plugin';
import { MadCapChangeSchemaPlugin } from '@common/flare/schema/madcap-change-schema-plugin';
import { MadCapCodeSnippetSchemaPlugin } from '@common/flare/schema/madcap-code-snippet-schema-plugin';
import { MadCapConceptSchemaPlugin } from '@common/flare/schema/madcap-concept-schema-plugin';
import { MadCapConditionSchemaPlugin } from '@common/flare/schema/madcap-condition-schema-plugin';
import { MadCapDropdownSchemaPlugin } from '@common/flare/schema/madcap-dropdown-schema-plugin';
import { MadCapELearningProxySchemaPlugin } from '@common/flare/schema/madcap-elearning-proxy-schema-plugin';
import { MadCapEquationSchemaPlugin } from '@common/flare/schema/madcap-equation-schema-plugin';
import { MadCapExpandingSchemaPlugin } from '@common/flare/schema/madcap-expanding-schema-plugin';
import { MadCapFootnoteSchemaPlugin } from '@common/flare/schema/madcap-footnote-schema-plugin';
import { MadCapGlossaryTermSchemaPlugin } from '@common/flare/schema/madcap-glossary-term-schema-plugin';
import { MadCapKeywordSchemaPlugin } from '@common/flare/schema/madcap-keyword-schema-plugin';
import { MadCapMicroContentSchemaPlugin } from '@common/flare/schema/madcap-micro-content-schema-plugin';
import { MadCapModel3DSchemaPlugin } from '@common/flare/schema/madcap-model-3d-schema-plugin';
import { MadCapMultimediaSchemaPlugin } from '@common/flare/schema/madcap-multimedia-schema-plugin';
import { MadCapMultipleChoiceSchemaPlugin } from '@common/flare/schema/madcap-multiple-choice-schema.plugin';
import { MadCapNamedDestinationSchemaPlugin } from '@common/flare/schema/madcap-named-destination-schema-plugin';
import { MadCapPageBreakSchemaPlugin } from '@common/flare/schema/madcap-page-break-schema-plugin';
import { MadCapPageFooterSchemaPlugin } from '@common/flare/schema/madcap-page-footer-schema-plugin';
import { MadCapPageHeaderSchemaPlugin } from '@common/flare/schema/madcap-page-header-schema-plugin';
import { MadCapPopupSchemaPlugin } from '@common/flare/schema/madcap-popup-schema-plugin';
import { MadCapProxySchemaPlugin } from '@common/flare/schema/madcap-proxy-schema-plugin';
import { MadCapQRCodeSchemaPlugin } from '@common/flare/schema/madcap-qr-code-schema-plugin';
import { MadCapRelatedTopicsSchemaPlugin } from '@common/flare/schema/madcap-related-topics-schema-plugin';
import { MadCapResponsiveContentSchemaPlugin } from '@common/flare/schema/madcap-responsive-content-schema-plugin';
import { MadCapShortcutSchemaPlugin } from '@common/flare/schema/madcap-shortcut-schema-plugin';
import { MadCapSlideshowSchemaPlugin } from '@common/flare/schema/madcap-slideshow-schema-plugin';
import { MadCapSnippetSchemaPlugin } from '@common/flare/schema/madcap-snippet-schema-plugin';
import { MadCapStyleSchemaPlugin } from '@common/flare/schema/madcap-style-schema-plugin';
import { MadCapTargetNameSchemaPlugin } from '@common/flare/schema/madcap-target-name-schema-plugin';
import { MadCapTogglerSchemaPlugin } from '@common/flare/schema/madcap-toggler-schema-plugin';
import { MadCapVariableSchemaPlugin } from '@common/flare/schema/madcap-variable-schema-plugin';
import { McCentralContainerSchemaPlugin } from '@common/flare/schema/mc-central-container-schema.plugin';
import { MMLSchemaPlugin } from '@common/flare/schema/mml-schema-plugin';
import { ParagraphSchemaPlugin } from '@common/flare/schema/paragraph-schema.plugin';
import { PreSchemaPlugin } from '@common/flare/schema/pre-schema-plugin';
import { ScriptSchemaPlugin } from '@common/flare/schema/script-schema.plugin';
import { SvgSchemaPlugin } from '@common/flare/schema/svg-schema.plugin';
import { TableSchemaPlugin } from '@common/flare/schema/table-schema-plugin';
import { TemplateSchemaPlugin } from '@common/flare/schema/template-schema.plugin';
import { TextSchemaPlugin } from '@common/flare/schema/text-schema.plugin';
import { UnknownSchemaPlugin } from '@common/flare/schema/unknown-schema-plugin';
import { WhitespaceSchemaPlugin } from '@common/flare/schema/whitespace-schema-plugin';
import { FlareSerializerExportOptions } from '@common/flare/types/to-flare-xml-options.type';
import { ValidationOptions } from '@common/html/types/serialization-options.type';
import { CollabSchema } from '@common/prosemirror/model/collab-schema';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { environment } from '@env/environment';
import { Fragment, MarkSpec, MarkType, NodeSpec, NodeType, ProseMirrorNode } from 'prosemirror-model';

// The canonical plugin list for the flare schema.
// Keep this in sync with the runtime construction order below.
const flareSchemaPluginConstructors = [
  FlareDocSchemaPlugin,
  ParagraphSchemaPlugin,
  TextSchemaPlugin,
  HeadingSchemaPlugin,
  IFrameSchemaPlugin,
  HeadSchemaPlugin,
  ImageSchemaPlugin,
  ListSchemaPlugin,
  DefinitionListSchemaPlugin,
  HrSchemaPlugin,
  BrSchemaPlugin,
  MadCapCentralCommentSchemaPlugin,
  MadCapCentralCDataSchemaPlugin,
  MadCapPageBreakSchemaPlugin,
  MadCapChangeSchemaPlugin,
  MadCapDropdownSchemaPlugin,
  MadCapSnippetSchemaPlugin,
  MadCapVariableSchemaPlugin,
  MadCapNamedDestinationSchemaPlugin,
  MadCapKeywordSchemaPlugin,
  MadCapConceptSchemaPlugin,
  MadCapTogglerSchemaPlugin,
  MadCapGlossaryTermSchemaPlugin,
  MadCapExpandingSchemaPlugin,
  MadCapPopupSchemaPlugin,
  MadCapProxySchemaPlugin,
  MadCapELearningProxySchemaPlugin,
  MadCapSlideshowSchemaPlugin,
  MadCapModel3DSchemaPlugin,
  MadCapQRCodeSchemaPlugin,
  MadCapMultimediaSchemaPlugin,
  MadCapEquationSchemaPlugin,
  MadCapShortcutSchemaPlugin,
  MadCapFootnoteSchemaPlugin,
  MadCapMicroContentSchemaPlugin,
  MadCapRelatedTopicsSchemaPlugin,
  MadCapPageHeaderSchemaPlugin,
  MadCapPageFooterSchemaPlugin,
  MadCapResponsiveContentSchemaPlugin,
  MadCapTargetNameSchemaPlugin,
  MadCapConditionSchemaPlugin,
  MadCapCodeSnippetSchemaPlugin,
  MadCapMultipleChoiceSchemaPlugin,
  MMLSchemaPlugin,
  LinkSchemaPlugin,
  FormSchemaPlugin,
  PreSchemaPlugin,
  ScriptSchemaPlugin,
  SvgSchemaPlugin,
  FramesetSchemaPlugin,
  BlockContainerSchemaPlugin,
  HtmlTagsSchemaPlugin,
  MadCapAnnotationSchemaPlugin,
  TableSchemaPlugin,
  TemplateSchemaPlugin,
  McCentralContainerSchemaPlugin,
  LegacySchemaPlugin,
  // Catch-all parsers for any HTML tag without a specific schema node — must come after all the specific plugins
  UnknownSchemaPlugin,
  // Modifies the specs on other nodes so these should go last
  MadCapStyleSchemaPlugin,
  WhitespaceSchemaPlugin,
  CustomAttributesSchemaPlugin
] as const;

// Build plugin instances from the constructor tuple while preserving tuple element types.
function createFlareSchemaPlugins() {
  return flareSchemaPluginConstructors.map(SchemaPluginClass => new SchemaPluginClass()) as Array<InstanceType<(typeof flareSchemaPluginConstructors)[number]>>;
}

// Union of all concrete plugin instance types in flareSchemaPluginConstructors.
type FlareSchemaPlugin = InstanceType<(typeof flareSchemaPluginConstructors)[number]>;
// Distributive helper: extracts node keys from each plugin, then unions the results.
type PluginNodeName<T extends SchemaPlugin<any, any>> = T extends any ? Extract<keyof T['nodes'], string> : never;
// Distributive helper: extracts mark keys from each plugin, then unions the results.
type PluginMarkName<T extends SchemaPlugin<any, any>> = T extends any ? Extract<keyof T['marks'], string> : never;

// All node and mark names contributed by schema plugins.
type FlarePluginNodeName = PluginNodeName<FlareSchemaPlugin>;
type FlarePluginMarkName = PluginMarkName<FlareSchemaPlugin>;

// Full schema node names are plugin-derived.
export type FlareNodeName = FlarePluginNodeName;
// Full schema mark names are currently plugin-derived.
export type FlareMarkName = FlarePluginMarkName;

// Converts a NodeSpec map (plugin-definition time) into a NodeType map (runtime schema API).
type NodeTypesFor<T extends Record<string, NodeSpec>> = {
  [K in keyof T]: NodeType;
};

// Reuse node-key metadata (including JSDoc/deprecation on keys) from the schema plugin type.
// Add new schema plugins if it helps surface deprecations for developers.
type MadCapCentralCommentNodeTypes = NodeTypesFor<MadCapCentralCommentSchemaNodes>;
type LegacyNodeTypes = NodeTypesFor<LegacySchemaNodes>;

export class FlareSchema extends CollabSchema<FlareNodeName, FlareMarkName> {
  // Keep strict inferred node names while also exposing key-level metadata from the schema plugins.
  declare readonly nodes: Record<FlareNodeName, NodeType> & MadCapCentralCommentNodeTypes & LegacyNodeTypes;
  declare readonly marks: Record<FlareMarkName, MarkType>;

  static DocMaxCharLength: number = environment.flareTextEditorDocMaxCharLength ? parseInt(environment.flareTextEditorDocMaxCharLength, 10) : 0;

  get docMaxCharLength(): number { return FlareSchema.DocMaxCharLength; }
  get name(): string { return 'flare'; }
  get version(): string { return '1.0.0'; }

  flareSerializer: FlareSerializer;

  constructor() {
    const schemaPlugins = createFlareSchemaPlugins();

    let nodes = {} as Record<FlareNodeName, NodeSpec>;
    const marks = {} as Record<FlareMarkName, MarkSpec>;

    // Add schema nodes and marks from the schema plugins
    schemaPlugins.forEach(plugin => {
      plugin.addNodes(nodes);
      plugin.addMarks(marks);
    });

    // Move the default block node to the beginning of the node map so that it is used as the default by ProseMirror
    const defaultBlockNodeName = 'paragraph';
    const defaultBlockNodeSpec = nodes[defaultBlockNodeName];
    if (!defaultBlockNodeSpec) {
      throw new Error(`Default block node not found in schema for ${defaultBlockNodeName}`);
    }
    // Create a new object with the default block node at the beginning
    nodes = { [defaultBlockNodeName]: defaultBlockNodeSpec, ...nodes };

    // Let the schema plugins modify the nodes and marks now that they are all added
    schemaPlugins.forEach(plugin => {
      plugin.modifyNodesAndMarks(nodes, marks);
    });

    super({ nodes, marks });

    this.flareSerializer = new FlareSerializer();

    // Add schema props from the schema modules
    schemaPlugins.forEach(plugin => {
      plugin.addProps(this);
    });
  }

  codeToDoc(code: string): ProseMirrorNode {
    return this.flareSerializer.codeToDoc(code, this);
  }

  nodeToCode(node: ProseMirrorNode, options?: FlareSerializerExportOptions): string {
    return this.flareSerializer.nodeToCode(node, this, options);
  }

  fragmentToCode(fragment: Fragment, options?: FlareSerializerExportOptions): string {
    return this.flareSerializer.fragmentToCode(fragment, this, options);
  }

  validate(code: string, options?: ValidationOptions): CollabDocSerializationError | null {
    return this.flareSerializer.validate(code, this, options);
  }

  nodeFromJSON(json: any): ProseMirrorNode {
    const node = super.nodeFromJSON(json);

    node?.descendants(childNode => {
      // If an attr on the node has a defaultFromJSON function and the attr has no value then call the function and set the attr value
      // This is used to set the default value for attributes that are not included in the JSON
      if (childNode.type.spec.attrs) {
        for (const [attrName, attrSpec] of Object.entries(childNode.type.spec.attrs)) {
          const attrValue = childNode.attrs[attrName];
          if (typeof attrSpec.defaultFromJSON === 'function' && (attrValue === undefined || attrValue === null)) {
            // Cast as any to set a readonly property
            (childNode.attrs as any)[attrName] = attrSpec.defaultFromJSON(json[attrName]);
          }
        }
      }
    });

    return node;
  }

  /**
   * Returns the display text for a tag name. Uses the node spec's toDisplayName if it exists. Then the node spec's tag name. Finally falling back to the node's name.
   * @param node The node to get the display name for.
   * @returns The display name for the node.
   */
  getTagDisplayName(node: ProseMirrorNode): string {
    // Use the toDisplayName function if it exists on the node
    if (typeof node.type.spec.toDisplayName === 'function') {
      return node.type.spec.toDisplayName(node);
    } else {
      return node.type.spec.tagName ?? node.type.name;
    }
  }

  skipAttrEditorExport(attrName: string, attrValue: string): boolean {
    const regex = FlareEditorElementAttributeWhitelist[attrName];
    return !attrName.startsWith('MadCap:') && !attrName.startsWith('mc-lwe-') && !attrName.startsWith('data-') && (!regex || !regex.test(attrValue));
  }
}
